<template>
  <v-stepper
    v-model="current"
  >
    <v-stepper-header>
      <v-stepper-step
        v-for="(state, i) in eventStates"
        :key="i"
        :step="i"
        :complete="i <= eventStates.indexOf(current)"
      >
        {{ state }}
      </v-stepper-step>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
import { mapGetters } from 'vuex';
import eventStates from '@/constants/eventStates';

export default {
  name: 'EventState',
  computed: {
    ...mapGetters({
      current: 'eventState',
    }),
    eventStates() {
      return eventStates;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-stepper__step__step {
    color: #fff;
    background: #004e7d;
    margin-right: 1rem;
    padding: 0;
  }

  .v-stepper__label {
    color: rgba(0,0,0,.87) !important;
  }
}
</style>
